import { removeRealtorByClient, removeRealtorByRealtor } from 'api';
import useRealtors, { APIRealtor } from 'api/hooks/use-realtors';
import BottomSheet from 'components/bottom-sheet';
import Button from 'components/button';
import ErrorMessage from 'components/error-message';
import Loader from 'components/loader';
import NotFound from 'components/not-found';
import { useState } from 'react';
import styles from './styles.module.scss';
import { formatPhone } from 'lib/utils';
import info from 'assets/images/info.svg';
import IconButton from 'components/icon-button';
import deleteIcon from 'assets/images/unbind.svg';
import useBoundStore from 'store';
import { APIUserType } from 'api/types';

export const RealtorsProfileTab: React.FC = () => {
  const [isRemovingRealtor, setIsRemovingRealtor] = useState(false);
  const [showRemoveBottomSheet, setShowRemoveBottomSheet] = useState<false | APIRealtor>(false);
  const user = useBoundStore((s) => s.user);

  const { realtors, error, isLoading, mutate } = useRealtors();

  const handleRemoveRealtor = async () => {
    if (showRemoveBottomSheet) {
      setIsRemovingRealtor(true);
      let res;
      if (user?.type === APIUserType.CLIENT) {
        res = await removeRealtorByClient(showRemoveBottomSheet.id);
      } else {
        res = await removeRealtorByRealtor(showRemoveBottomSheet.id);
      }

      setIsRemovingRealtor(false);

      if (res.result) {
        mutate();
      }

      setShowRemoveBottomSheet(false);
    }
  };

  const handleDissmissBottomSheet = () => setShowRemoveBottomSheet(false);

  return (
    <>
      <div>
        {isLoading ? (
          <Loader />
        ) : error ? (
          <ErrorMessage message={error} />
        ) : realtors.length > 0 ? (
          realtors.map((realtor) => (
            <div key={realtor.id} className={styles.realtor}>
              <div className={styles.realtorInfo}>
                <div className={styles.realtorContainer}>
                  <div>
                    <div className={styles.realtorName}>{realtor.name} </div>
                    <div className={styles.realtorPhone}>{formatPhone(realtor.phone)}</div>
                  </div>
                  <IconButton icon={deleteIcon} onClick={() => setShowRemoveBottomSheet(realtor)} />
                </div>
              </div>
            </div>
          ))
        ) : (
          <NotFound />
        )}
      </div>

      <BottomSheet open={!!showRemoveBottomSheet} onDismiss={handleDissmissBottomSheet}>
        <div className={styles.dismissRealtorContainer}>
          <img alt='Значок "i"' src={info} width={60} height={60} />
          <div className={styles.dismissRealtorHeader}>Открепить риелтора?</div>
          <div className={styles.dismissRealtorQuestion}>
            Открепляемый риелтор{' '}
            <span className={styles.realtorName}>{`${
              showRemoveBottomSheet && showRemoveBottomSheet.name
            } `}</span>
            не сможет взаимодействовать с Вами в системе
          </div>
        </div>

        <Button label='Открепить' loading={isRemovingRealtor} onClick={handleRemoveRealtor} />
        <Button
          label='Нет, я передумал'
          variant='transparent'
          onClick={handleDissmissBottomSheet}
        />
      </BottomSheet>
    </>
  );
};
